import { apiCall } from './gqlClient';

const ATHLETEPROFILES_QUERY = `
  query athleteProfiles($providerId: Float!) {
    athleteProfiles(providerId: $providerId)
    {
      id
			providerId
			userId
			firstName
			lastName
			experienceLevel
			equipmentContext
			intakeCompletedAt
			intakeStatus
			intakeRequestedAt
			intakeSubmittedAt
			data
			schemaVersion
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const athleteProfilesApiCall = async ({providerId}, fragments = null) => apiCall({ query: ATHLETEPROFILES_QUERY, variables: {providerId}, fragments });

const MYATHLETEPROFILES_QUERY = `
  query myAthleteProfiles {
    myAthleteProfiles
    {
      id
			providerId
			userId
			firstName
			lastName
			experienceLevel
			equipmentContext
			intakeCompletedAt
			intakeStatus
			intakeRequestedAt
			intakeSubmittedAt
			data
			schemaVersion
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const myAthleteProfilesApiCall = async (fragments = null) => apiCall({ query: MYATHLETEPROFILES_QUERY, variables: {}, fragments });

const ATHLETEPROFILE_QUERY = `
  query athleteProfile($id: String!) {
    athleteProfile(id: $id)
    {
      id
			providerId
			userId
			firstName
			lastName
			experienceLevel
			equipmentContext
			intakeCompletedAt
			intakeStatus
			intakeRequestedAt
			intakeSubmittedAt
			data
			schemaVersion
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const athleteProfileApiCall = async ({id}, fragments = null) => apiCall({ query: ATHLETEPROFILE_QUERY, variables: {id}, fragments });

const MYATHLETEINTAKE_QUERY = `
  query myAthleteIntake {
    myAthleteIntake
    {
      linked
			profileId
			providerId
			firstName
			lastName
			experienceLevel
			equipmentContext
			intakeStatus
			intakeRequestedAt
			intakeSubmittedAt
			data
			schemaVersion
      ...fragments
    }
  }`;

export const myAthleteIntakeApiCall = async (fragments = null) => apiCall({ query: MYATHLETEINTAKE_QUERY, variables: {}, fragments });

const CREATEATHLETEPROFILE_QUERY = `
  mutation createAthleteProfile($input: AthleteProfileInput!) {
    createAthleteProfile(input: $input)
    {
      id
			providerId
			userId
			firstName
			lastName
			experienceLevel
			equipmentContext
			intakeCompletedAt
			intakeStatus
			intakeRequestedAt
			intakeSubmittedAt
			data
			schemaVersion
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const createAthleteProfileApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEATHLETEPROFILE_QUERY, variables: {input}, fragments });

const UPDATEATHLETEPROFILE_QUERY = `
  mutation updateAthleteProfile($id: String!, $input: AthleteProfileInput!) {
    updateAthleteProfile(id: $id, input: $input)
    {
      id
			providerId
			userId
			firstName
			lastName
			experienceLevel
			equipmentContext
			intakeCompletedAt
			intakeStatus
			intakeRequestedAt
			intakeSubmittedAt
			data
			schemaVersion
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const updateAthleteProfileApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATEATHLETEPROFILE_QUERY, variables: {id, input}, fragments });

const REQUESTATHLETEINTAKE_QUERY = `
  mutation requestAthleteIntake($profileId: String!) {
    requestAthleteIntake(profileId: $profileId)
    {
      id
			providerId
			userId
			firstName
			lastName
			experienceLevel
			equipmentContext
			intakeCompletedAt
			intakeStatus
			intakeRequestedAt
			intakeSubmittedAt
			data
			schemaVersion
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const requestAthleteIntakeApiCall = async ({profileId}, fragments = null) => apiCall({ query: REQUESTATHLETEINTAKE_QUERY, variables: {profileId}, fragments });

const REVIEWATHLETEINTAKE_QUERY = `
  mutation reviewAthleteIntake($profileId: String!) {
    reviewAthleteIntake(profileId: $profileId)
    {
      id
			providerId
			userId
			firstName
			lastName
			experienceLevel
			equipmentContext
			intakeCompletedAt
			intakeStatus
			intakeRequestedAt
			intakeSubmittedAt
			data
			schemaVersion
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const reviewAthleteIntakeApiCall = async ({profileId}, fragments = null) => apiCall({ query: REVIEWATHLETEINTAKE_QUERY, variables: {profileId}, fragments });

const SUBMITMYATHLETEINTAKE_QUERY = `
  mutation submitMyAthleteIntake($data: JSON!, $firstName: String, $lastName: String) {
    submitMyAthleteIntake(data: $data, firstName: $firstName, lastName: $lastName)
    {
      id
			providerId
			userId
			firstName
			lastName
			experienceLevel
			equipmentContext
			intakeCompletedAt
			intakeStatus
			intakeRequestedAt
			intakeSubmittedAt
			data
			schemaVersion
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const submitMyAthleteIntakeApiCall = async ({data, firstName, lastName}, fragments = null) => apiCall({ query: SUBMITMYATHLETEINTAKE_QUERY, variables: {data, firstName, lastName}, fragments });
